
import React from 'react';

const Marketing = () => {
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1, padding: '20px' }}>
        <h2>Marketing</h2>
        <p>Manage marketing campaigns, promotional tools, and analytics here.</p>
      </div>
    </div>
  );
};

export default Marketing;
